module.exports = __webpack_public_path__ + "img/zf_5@2x.fc619990.png";